import {PayloadAction, createSlice} from '@reduxjs/toolkit'
import {RootState} from '../../store'
import {TOrder, TOrderSubDetail} from '../types'
import {IFetchJBPPriceDetailResponse} from '../../services/types'

export type TMenuAccess = {
  approve?: boolean
  attachment?: boolean
  attachment_delete?: boolean
  create?: boolean
  delete?: boolean
  export?: boolean
  icon?: null | string
  id?: number
  name?: string
  name_ind?: string
  parent_id?: number
  print?: boolean
  read?: boolean
  update?: boolean
  uri?: string
}

export interface IState {
  selectedMenu: null | TMenuAccess
  selectedMenuParent: null | {
    id: number
    role_id: number
    menu_id: number
    create: boolean
    read: boolean
    update: boolean
    delete: boolean
    approve: boolean
    export: boolean
    print: boolean
    attachment: boolean
    attachment_delete: boolean
    menu: {
      id: number
      name: string
      name_ind: string
      uri: string
      sort: number
      parent_id: number | null
      icon_id: number
      icon: {
        id: number
        icon_path: string
      }
      sub_menu: TMenuAccess[]
    }
  }
  orderDetail: TOrder | null
  orderSubDetail: TOrderSubDetail | null
  beforeAmandement: TOrderSubDetail | null
  jbpDetail: IFetchJBPPriceDetailResponse['data']
}

const initialState: IState = {
  selectedMenu: null,
  selectedMenuParent: null,
  orderDetail: null,
  orderSubDetail: null,
  beforeAmandement: null,
  jbpDetail: null,
}

const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    setSelectedMenu: (state: IState, action: PayloadAction<IState['selectedMenu']>) => {
      state.selectedMenu = action.payload
    },
    setSelectedMenuParent: (state: IState, action: PayloadAction<IState['selectedMenuParent']>) => {
      state.selectedMenuParent = action.payload
    },
    setOrderDetail: (state: IState, action: PayloadAction<TOrder>) => {
      state.orderDetail = action.payload
    },
    setOrderSubDetail: (state: IState, action: PayloadAction<TOrderSubDetail>) => {
      state.orderSubDetail = action.payload

      const before_amandement = action.payload.before_amandement
      const hasBeforeAmandement = before_amandement && before_amandement.length > 0
      state.beforeAmandement = hasBeforeAmandement ? before_amandement[0] : null
    },
    setJbpDetail: (state, action: PayloadAction<IFetchJBPPriceDetailResponse['data']>) => {
      state.jbpDetail = action.payload
    },
  },
})

export const {
  setSelectedMenu,
  setSelectedMenuParent,
  setOrderDetail,
  setOrderSubDetail,
  setJbpDetail,
} = appSlice.actions

export const appSelector = (state: RootState) => state.appPersistedReducer
export default appSlice.reducer
